import styled, { css } from 'styled-components';
import { isMobileStyleMixin, Text } from '@amzn/storm-ui';

const OptionsContainer = /*#__PURE__*/styled.div.attrs({
  role: 'radiogroup'
}).withConfig({
  componentId: "sc-storm-ui-30062554__sc-keh7kz-0"
})(["padding-inline-start:", ";padding-inline-end:", ";display:flex;gap:", ";flex-direction:row;justify-content:space-between;flex-wrap:wrap;"], ({
  $variant,
  theme
}) => $variant === 'emoji' ? theme.spacing.base : 0, ({
  $variant,
  theme
}) => $variant === 'emoji' ? theme.spacing.base : 0, ({
  theme
}) => theme.spacing.mini);
const OptionsPartWrapper = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30062554__sc-keh7kz-1"
})(["display:flex;width:100%;justify-content:", ";flex-wrap:wrap;"], ({
  $justifyContent
}) => $justifyContent !== null && $justifyContent !== void 0 ? $justifyContent : 'space-between');
const StyledFieldset = /*#__PURE__*/styled.fieldset.withConfig({
  componentId: "sc-storm-ui-30062554__sc-keh7kz-2"
})(["border:0;padding:0;margin:0;min-width:0;& > * + *{margin-block-start:2px;}"]);
const StyledLegend = /*#__PURE__*/styled.legend.withConfig({
  componentId: "sc-storm-ui-30062554__sc-keh7kz-3"
})(["", " font-weight:", ";color:", ";padding-left:0;padding-bottom:0;padding-right:0;padding-top:0;", ""], ({
  theme
}) => theme.typography.base, ({
  theme
}) => theme.form.label.weight, ({
  theme
}) => theme.form.label.color, isMobileStyleMixin(css(["", ""], ({
  theme
}) => theme.typography.mobile.base)));
const DescriptionContainer = /*#__PURE__*/styled.div.attrs({
  'aria-hidden': true
}).withConfig({
  componentId: "sc-storm-ui-30062554__sc-keh7kz-4"
})(["display:flex;flex-direction:row;justify-content:space-between;margin-block-end:6px;"]);
const DescriptionText = /*#__PURE__*/styled(Text).attrs({
  type: 'span',
  textColor: 'base',
  fontSize: 'base'
}).withConfig({
  componentId: "sc-storm-ui-30062554__sc-keh7kz-5"
})([""]);

export { DescriptionContainer as D, OptionsContainer as O, StyledFieldset as S, OptionsPartWrapper as a, StyledLegend as b, DescriptionText as c };
//# sourceMappingURL=SentimentScale.styles-fdWAK_KI.js.map
